import {Injectable} from '@angular/core';
import {TOOL} from 'src/app/constants/map';

@Injectable({
    providedIn: 'root'
})
export class MapboxglCustomZoomOutControl {

    private container: any;
    public service: any;
    public button: HTMLButtonElement;
    private readonly clickHandler: () => void;
    private icon: any;

    constructor(
        {mapboxglService}
    ) {
        this.service = mapboxglService;
        this.clickHandler = this.handleClick.bind(this);
    }

    handleClick = () => {
        // Xử lý sự kiện zoom in
        this.icon = this.button.querySelector<HTMLElement>('.material-icons-outlined');
        if (this.icon) {
            this.button.classList.add('active');
            this.icon.style.color = 'red';
            setTimeout(() => {
                this.icon.style.color = 'black';
                this.button.classList.remove('active');
            }, 100);
        }
        this.service.map.zoomOut();
    }

    eventClick(e: any): void {
        this.button = e.currentTarget;
        this.handleClick();
    }

    onAdd(): void {
        const customZoomOutToolInfo: TOOL = {
            name: 'Zoom out',
            // iconClass: 'esri-icon esri-icon-minus',
            iconClass: 'material-icons-outlined',
            code: 'CUSTOM_ZOOM_OUT',
            active: false,
            className: 'remove'
        };

        const customZoomOutTool = this.service.utilityFn.createTool(customZoomOutToolInfo, this.eventClick.bind(this));
        this.container = this.service.utilityFn.createControl([customZoomOutTool], 'mapbox-gl-custom_zoom_out');
        return this.container;
    }

    onRemove(): void {
        this.container.parentNode.removeChild(this.container);
        this.service.map = undefined;
    }
}
